// initialed state
export const initialState = () => ({
	selectedProjectId: null,
	loadingWorkflowsFlag: false,
});

const state = initialState();

export default state;
